<template>
     <div>
        <div class="form-group">
            <label class="form-switch form-inline">
                <input type="checkbox" v-on:click="xhr()"><i class="form-icon"></i>Filter
            </label>
        </div>
        <div style="height: 90vh; width: 100%">
            <l-map ref="myMap" :zoom="zoom" :center="center" :options="mapOptions">
                <l-control-layers :position="'topleft'" />
                <l-tile-layer
                    v-for="layer in layers"
                    :key="layer.name"
                    :url="layer.url"
                    :name="layer.name"
                    :options="layer.options"
                    :attribution="layer.attribution"
                    :visible="layer.visible"
                    layer-type="base"
                />
            <l-marker v-for="(position, index) in positions" :key="index"
            :lat-lng="[position.lat, position.lng]"
            />
            </l-map>
        </div>
    </div>
</template>

<script>
import { LMap, LControlLayers, LTileLayer, LMarker} from 'vue2-leaflet';
import { latLng } from "leaflet";
import axios from 'axios';
const api_url = process.env.VUE_APP_AIRFIELD

export default {
    name: 'Airfield',
    components: {
                LMap,
                LControlLayers,
                LTileLayer,
                LMarker
    },
    data () {
        return {
            filter: true,
            mapOptions: {
                zoomSnap: 0.5,
                zoomControl: false
            },
            zoom: 12,
            center: latLng(47.79861666666667, 3.7813333333333334),
            layers: [
                {
                    name: 'Esri',
                    url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    options: {maxNativeZoom: 15},
                    attribution: '<a href="http://www.esri.com/" target="_blank">Esri</a>',
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'Stamen',
                    url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
                    options: {maxNativeZoom: 12},
                    attribution: '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; \
                    <a href="https://stamen.com/" target="_blank">Stamen Design</a> &copy; \
                    <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; \
                    <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
                    visible: false
                },
                {
                    name: 'OpenTopoMap',
                    url: 'http://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                    attribution: '<a href="http://opentopomap.org" target="_blank">OpenTopoMap</a>',
                    options: {maxNativeZoom: 15},
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'OpenStreetMap',
                    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
                    visible: true
                },
            ],
            positions: [],
            days: null,
        }
    },
    mounted (){
        this.days = this.$route.params.days
        this.xhr()
    },
    methods: {
        xhr() {
            this.filter = !this.filter
            console.log("filter:", this.filter)
            if (this.filter === false){
                axios
                .get([api_url, this.days].join('/'))
                .then(response=>{
                    let fitbound = []
                    this.positions = response.data
                    this.positions.forEach(elt => fitbound.push([elt.lat, elt.lng]));
                    if (fitbound.length >=2) this.$refs.myMap.mapObject.fitBounds(fitbound)
                    else if (fitbound.length ==1) this.$refs.myMap.mapObject.panTo(latLng(this.positions[0].lat, this.positions[0].lng))
                })
                .catch(error =>{console.log("Error while consuming Api:" + error)})
            }
            else {
                axios
                .post([api_url, this.days].join('/'))
                .then(response=>{
                    let fitbound = []
                    this.positions = response.data
                    this.positions.forEach(elt => fitbound.push([elt.lat, elt.lng]));
                    if (fitbound.length >=2) this.$refs.myMap.mapObject.fitBounds(fitbound)
                    else if (fitbound.length ==1) this.$refs.myMap.mapObject.panTo(latLng(this.positions[0].lat, this.positions[0].lng))
                })
                .catch(error =>{console.log("Error while consuming Api:" + error)})
            }
        },
    }
}
</script>